<template>
  <div>
    <table id="tabela-status_produto-ref">
      <template v-for="(serie, index) in LINHAS">
        <tr :key="index" :class="index" :title="nomes[index]" style="">
          <td style="width: 3.5vw !important;">
            <div v-if="index != 'referencias'" class="quadrado-17 border-full mx-auto" :style="{ background: cores[index] }">&nbsp;</div>
          </td>

          <template v-for="(value, index1) in serie">
            <td
              :key="`${index}-${value}-${index1}`"
              style="width: 7.37vw !important; cursor: pointer;"
              :style="{ cursor: index != 'referencias' ? 'pointer' : '' }"
              @click="abrirDialogDetalhes(index, index1, serie)"
            >
              <span v-if="index == 'referencias'" class="font-bold">{{ value }}</span>
              <span v-else>{{ Helpers.formatarValor(Object.values(value)[0]) }}</span>
            </td>
          </template>
        </tr>
      </template>
    </table>
    <DialogDetalhes v-model="dialog_detalhes" :parametros="parametros" />
  </div>
</template>

<script>
import moment from 'moment';
import { cores, nomes } from "../InformacoesGrafico";
import DialogDetalhes from './DialogDetalhes.vue';

export default {
  components: { DialogDetalhes },
  name: "Grid",
  props: {
    dados: [Array, Object],
    filtros: Object
  },
  data: ()=> ({
    cores,
    nomes,
    dialog_detalhes: false,
    parametros: {}
  }),
  computed: {
    LINHAS() {
      return this.dados.tabela;
    }
  },
  methods: {
    formatarTextoMaiusculo(_string) {
      if(!moment(_string)) return;

      let str = _string;
      let sentences = str.split(/[.;?!_]/);
      for (let i = 0; i < sentences.length; i++) {
        let sentence = sentences[i].trim();
        if (sentence !== "") {
          sentences[i] = sentence.charAt(0).toUpperCase() + sentence.slice(1);
        }
      }
      let newStr = sentences.join(" ") ;
      return newStr;
    },
    abrirDialogDetalhes(idx, idx1, serie) {
      if (idx == 'referencias') return;
      const tipo = idx;
      const data = Object.keys(serie[idx1])[0];
      const parametros = {
        tipo: tipo,
        data: data,
        filtros: this.filtros
      }

      this.parametros = parametros;
      this.dialog_detalhes = true;
    }
  }
}
</script>

<style scoped>
#tabela-status_produto-ref {
  border-collapse: collapse;
}
#tabela-status_produto-ref tr td {
  text-align: center;
  padding: 5px 0;
  font-size: 12px;
  color: #3a3a3a;
}
.border-full {
  border: 1px solid #939292;
}
.total_adequado:hover {
  background: rgba(0, 174, 81, 0.35);
}
.total_excesso:hover {
  background: rgba(4, 35, 51, 0.35);
}
.total_baixa_exposicao:hover {
  background: rgba(255, 254, 2, 0.35)
}
.total_elevada_exposicao:hover {
  background: rgba(255, 191, 5, 0.35);
}
.total_ruptura:hover {
  background: rgba(253, 0, 1, 0.35);
}
</style>
